import { Component, OnInit, Optional, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PlainResultModalComponent } from '../../../../../../shared/components/plain-result-modal/plain-result-modal.component';
import { StringHelper } from '../../../../../../core/helpers/strings.helper';
import { TransferService } from '../../../../../../core/services/transfer.service';
import { BaseFormComponent } from '../../../../base-form/base-form.component';
import { ModalOptionsConfig, ModalService } from '../../../../nz-modal-service/modal.service';
import { DialogMessageType } from '../../../../../../shared/models/utility.model';
import { CustomFormControl, CustomFormControlDefinition } from '../../../../../../shared/utils/custom-form-control';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-edit-transaction-limit-modal',
    templateUrl: './edit-transaction-limit-modal.component.html',
    styleUrls: ['./edit-transaction-limit-modal.component.scss'],
})
export class EditTransactionLimitModalComponent extends BaseFormComponent implements OnInit {
    isMobile: boolean;
    dailyLimitAmountControl: CustomFormControlDefinition;
    form: FormGroup;
    maxDailyLimit: number;
    isLoading: boolean;
    runningModal: NzModalRef;
    transactionType: 'Transfer' | 'Airtime' | 'Bill Payment';
    readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

    constructor(
        private fb: FormBuilder,
        @Optional() public modalRef: NzModalRef,
        private modalService: ModalService,
        private transferService: TransferService,
    ) {
        super(fb);
    }
    ngOnInit(): void {
        this.modalRef.componentInstance = { ...this.modalRef.componentInstance, ...this.nzModalData };
        this.isMobile = this.modalRef.componentInstance?.data?.isMobile;
        this.maxDailyLimit = this.modalRef.componentInstance?.data?.maxDailyLimit;
        this.transactionType = this.modalRef.componentInstance?.data?.transactionType;
        this.setCustomFormControls();
    }

    setCustomFormControls() {
        this.dailyLimitAmountControl = new CustomFormControl()
            .id('daily-transfer-limit')
            .placeholder('Daily ' + this.transactionType + ' Limit')
            .name('daily-transfer-limit')
            .maxValue(this.maxDailyLimit / 100)
            .isCurrencyAmount()
            .isRequired()
            .build();

        this.form = this.fb.group({
            dailyLimitAmount: this.dailyLimitAmountControl.formGroupControl,
        });
    }

    back() {
        this.modalRef.destroy();
    }

    getUpdateLimitbyTransactionType(params) {
        switch (this.transactionType) {
            case 'Transfer':
                return this.transferService.updateDailyTransferLimit(params);
                break;
        }
    }

    updateDailyTransferLimit() {
        this.isLoading = true;
        const dailyTranferLimit = parseInt(this.form.get('dailyLimitAmount').value.toString()) * 100;
        const params = {
            dailyTransferLimit: dailyTranferLimit,
        };

        const data: any = {};
        data.isMobile = this.isMobile;
        this.getUpdateLimitbyTransactionType(params)
            .then((res) => {
                data.modalTitle = 'Daily Transfer Limit Updated SuccesFully';
                data.messageType = DialogMessageType.SUCCESS;
                this.modalRef.componentInstance.callback(dailyTranferLimit);
            })
            .catch((error) => {
                data.messageType = DialogMessageType.FAILURE;
                data.modalBody = StringHelper.getErrorMessageHttpErrorResponse(error);
                data.modalTitle = `Daily Transfer Limit Update Failed!`;
            })
            .finally(() => {
                this.isLoading = false;
                this.launchResultModal(data);
            });
    }

    launchResultModal(data) {
        const config = new ModalOptionsConfig();
        config.nzClosable = false;
        config.nzMaskClosable = false;
        config.nzCentered = false;
        config.nzComponentParams.data = data;
        config.nzComponentParams.callback = (result) => {
            if (!(result === 'FAILURE')) {
                this.modalRef.destroy();
            }
            this.runningModal.destroy();
        };
        this.runningModal = this.modalService.createModal(PlainResultModalComponent, config);
    }
}
